export default __webpack_public_path__ + "afb32c0a4d71149a4d6c641ba53f1462.ttf";